import axios from "axios";
import { alertErrorMessage } from "../../customComponent/CustomAlertMessage";

// Public endpoints that don't need to SEND credentials (but may RECEIVE cookies)
const PUBLIC_ENDPOINTS = [
  '/send-otp',
  '/getLoginOtp',
  '/forgot_password',
  '/new_password',
  '/newPassword'
];

// Check if URL is a public endpoint (no credentials needed to send)
const isPublicEndpoint = (url) => {
  return PUBLIC_ENDPOINTS.some(endpoint => url.includes(endpoint));
};

export const ApiCallPost = async (url, parameters, headers) => {
  try {
    const response = await axios.post(url, parameters, { 
      headers: headers,
      withCredentials: !isPublicEndpoint(url) // Don't send credentials for public endpoints
    });
    return response.data;
  } catch (error) {
    if (error.response.data.message === "Token is expired" || 
        error.response.data.message === "Admin not found this email" || 
        error.response.data.message === "Admin does not have access" || 
        error.response.data.message === "Unauthorized Request!" ||
        error.response.data.message === "Session not found or already invalidated" ||
        error.response.data.reason === "session_not_found") {
      tokenExpire(error.response.data.message)
      return;
    }
    if (error.response.data.message === "IP not whitelisted for this signid") {
      ipNotWhitelisted(error.response.data.message)
      return;
    }
    return error.response.data;
  }
};

export const ApiCallDelete = async (url, headers) => {
  try {
    const response = await axios.delete(url, { 
      headers: headers,
      withCredentials: !isPublicEndpoint(url) // Don't send credentials for public endpoints
    });
    return response.data;
  } catch (error) {
    if (error.response.data.message === "Token is expired" || 
        error.response.data.message === "Admin not found this email" || 
        error.response.data.message === "Admin does not have access" || 
        error.response.data.message === "Unauthorized Request!" ||
        error.response.data.message === "Session not found or already invalidated" ||
        error.response.data.reason === "session_not_found") {
      tokenExpire(error.response.data.message)
      return;
    }
    if (error.response.data.message === "IP not whitelisted for this signid") {
      ipNotWhitelisted(error.response.data.message)
      return;
    }
    return error.response.data;
  }
};


export const ApiCallGet = async (url, headers) => {
  try {
    const response = await axios.get(url, { 
      headers: headers,
      withCredentials: !isPublicEndpoint(url) // Don't send credentials for public endpoints
    });
    return response.data;

  } catch (error) {
    if (error.response.data.message === "Token is expired" || 
        error.response.data.message === "Admin not found this email" || 
        error.response.data.message === "Admin does not have access" || 
        error.response.data.message === "Unauthorized Request!" ||
        error.response.data.message === "Session not found or already invalidated" ||
        error.response.data.reason === "session_not_found") {
      tokenExpire(error.response.data.message)
      return;
    }
    if (error.response.data.message === "IP not whitelisted for this signid") {
      ipNotWhitelisted(error.response.data.message)
      return;
    }
    return error.response.data;
  }
};

export const ApiCallPut = async (url, parameters, headers) => {
  try {
    const response = await axios.put(url, parameters, { 
      headers: headers,
      withCredentials: !isPublicEndpoint(url) // Don't send credentials for public endpoints
    });
    return response.data;
  } catch (error) {
    if (error.response.data.message === "Token is expired" || 
        error.response.data.message === "Admin not found this email" || 
        error.response.data.message === "Admin does not have access" || 
        error.response.data.message === "Unauthorized Request!" ||
        error.response.data.message === "Session not found or already invalidated" ||
        error.response.data.reason === "session_not_found") {
      tokenExpire(error.response.data.message)
      return;
    }
    if (error.response.data.message === "IP not whitelisted for this signid") {
      ipNotWhitelisted(error.response.data.message)
      return;
    }
    return error.response.data;
  }
};

export const ApiCallPatch = async (url, parameters, headers) => {
  try {
    const response = await axios.patch(url, parameters, { 
      headers: headers,
      withCredentials: !isPublicEndpoint(url) // Don't send credentials for public endpoints
    });
    return response.data;
  } catch (error) {
    if (error.response.data.message === "Token is expired" || 
        error.response.data.message === "Admin not found this email" || 
        error.response.data.message === "Admin does not have access" || 
        error.response.data.message === "Unauthorized Request!" ||
        error.response.data.message === "Session not found or already invalidated" ||
        error.response.data.reason === "session_not_found") {
      tokenExpire(error.response.data.message)
      return;
    }
    if (error.response.data.message === "IP not whitelisted for this signid") {
      ipNotWhitelisted(error.response.data.message)
      return;
    }
    return error.response.data;
  }
};

const tokenExpire = (message) => {
  alertErrorMessage(message);
  sessionStorage.clear();
  window.location.reload();
};

const ipNotWhitelisted = (message) => {
  alertErrorMessage(message);
  sessionStorage.clear();
};